import MUIContainer from '@/components/MUI-Components/MUI-Container';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import useMediaQuery from '@mui/material/useMediaQuery';
import React, {memo} from 'react';
import DisplayImage from '../display-image';
import {colors, fontSize} from '@/styles/tokens';

// Migrated from globals.scss `.real-estate-serve-image`. Sole owner confirmed — this class's only
// current consumer is the DisplayImage rendered below, via this component's single call site
// (real-estate-tokenization-legal-consulting/index.tsx). Applied through DisplayImage's existing
// `sx` passthrough (already part of its public API — no new prop added), which it documents as
// being applied directly to the rendered img with no wrapper element. `100%`/`auto` are plain
// sizing keywords, not scale values — no token in `@/styles/tokens` applies.
//
// NOTE: a second globals.scss rule, `.legal-consulting-serve-wrapper .real-estate-serve-image {
// max-width: 500px !important; }`, also targets this class but is keyed off a page-authored
// ancestor wrapper className (added by the page to its own Grid item, not by this component's
// JSX) rather than anything owned here — left untouched/global; see migration report for the
// open question on how/whether to fold it in.
const realEstateServeImageSx = {
    width: '100%',
    height: 'auto'
} as const;

const RealEstateServe = (props: any) => {
    const {heading, subheading, ImageSrc, contentData} = props;
    const smallScreen = useMediaQuery('(max-width:768px)');

    return (
        <Box>
            <MUIContainer>
                <Grid container spacing={3}>
                    <Grid item md={6} xs={12}>
                        <Box className="spectrum-header-wrapper solutions trend-dominate-text-wrapper" pb={2}>
                            <Typography className="spectrum-heading color-black " component="h2" pb={2}>
                                {heading}
                            </Typography>
                            <Typography className="spectrum-sub-heading color-black" component="p">
                                {subheading}
                            </Typography>
                            <Grid container spacing={4}>
                                {contentData?.map((item: any, index: number) => (
                                    <Grid item xs={12} sm={6} key={index}>
                                        <Card
                                            sx={{
                                                height: '100%',
                                                borderRadius: '3px',
                                                p: 3,
                                                backgroundColor: colors.background.default,
                                                boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.2)'
                                            }}
                                        >
                                            <CardContent sx={{p: 0, pb: '0px !important'}}>
                                                <DisplayImage src={item.src} alt={item.heading} />

                                                <Typography variant="h6" fontWeight="bold" gutterBottom sx={{fontSize: fontSize[18]}}>
                                                    {item.heading}
                                                </Typography>
                                                <Typography variant="body2" color="#2f2f2f" sx={{fontSize: fontSize[15]}}>
                                                    {item.subheading}
                                                </Typography>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                ))}
                            </Grid>
                        </Box>
                    </Grid>
                    {!smallScreen && (
                        <Grid item md={6} sx={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                            <DisplayImage alt={heading} src={ImageSrc} className="real-estate-serve-image" sx={realEstateServeImageSx} />
                        </Grid>
                    )}
                </Grid>
            </MUIContainer>
        </Box>
    );
};

export default memo(RealEstateServe);
